export default __webpack_public_path__ + "static/media/35t_van_filled.bdb4965b.svg";